class FeesProduct extends HTMLElement {
  static GRAMS_PER_LB = 453.592

  static STYLES = `
    fees-product { display: block; }
    .fees-product__option {
      display: flex;
      align-items: flex-start;
      gap: 10px;
      margin-top: 6px;
      padding: 12px 10px;
      border-radius: 8px;
      color: #683e1f;
      font-family: Arial, Helvetica, sans-serif;
      font-size: 20px;
      line-height: 1.4;
      cursor: pointer;
    }
    .fees-product__option input[type="checkbox"] {
      flex: 0 0 auto;
      width: 24px;
      height: 24px;
      margin-top: 2px;
      accent-color: #cd7e44;
      cursor: pointer;
    }
    .fees-product__option-text {
      display: flex;
      flex-direction: column;
      gap: 4px;
      text-align: left;
    }

    .npt-product-info .fees-product__option {
      font-size: 16px;
    }

    .npt-product-info .fees-product__option input[type="checkbox"] {
      width: 16px;
      height: 16px;
    }



    @media screen and (max-width: 749px) {
      .fees-product__option input[type="checkbox"] {
        width: 13px;
        height: 13px;
      }

      .fees-product__option {
        font-size: 13px;
      }
    }

    .fees-product__price {
      font-weight: 600;
      color: #cd7e44;
    }

    .fees-product__title {
      display: flex;
      align-items: center;
      gap: 6px;
      margin: 12px 0 0;
      font-family: Arial, Helvetica, sans-serif;
      font-size: 24px;
      font-weight: 600;
      color: #683e1f;
    }

    .npt-product-info .fees-product__title {
      font-size: 18px;
    }

    @media screen and (max-width: 749px) {
      .fees-product__title {
        font-size: 16px;
      }

      .npt-product-info .fees-product__title {
        font-size: 14px;
      }
    }


    .fees-product__info-wrap {
      display: none;
      position: relative;
    }
    .fees-product__info-icon {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 16px;
      height: 16px;
      border-radius: 50%;
      background: #333232;
      color: #fff;
      font-size: 11px;
      font-weight: 700;
      cursor: help;
    }
    .fees-product__tooltip {
      display: none;
      position: absolute;
      left: 50%;
      bottom: calc(100% + 6px);
      transform: translateX(-50%);
      width: 260px;
      padding: 8px 10px;
      border-radius: 6px;
      background: #683e1f;
      color: #fff;
      font-size: 14px;
      font-weight: 400;
      line-height: 1.4;
      z-index: 1;
      text-align: left;
    }
    .fees-product__info-wrap:hover .fees-product__tooltip,
    .fees-product__info-wrap:focus-within .fees-product__tooltip {
      display: block;
    }
    .fees-product__description {
      margin: 4px 0 0;
      font-size: 12px;
      font-weight: 400;
      line-height: 1.4;
      color: #545454;
      text-align: left;
    }
    .fees-product__additional-description {
      margin: 0;
      font-size: 14px;
      font-weight: 400;
      line-height: 1.4;
      color: #545454;
      text-align: left;
    }
    .fees-product__additional-description p {
      margin: 0;
    }
    @media screen and (min-width: 750px) {
      .fees-product__info-wrap { display: flex; }
      .fees-product__description { display: none; }
    }
  `

  static _escapeHtml(value) {
    const div = document.createElement('div')
    div.textContent = value
    return div.innerHTML
  }

  static _parseInterval(text) {
    if (!text) return null
    const match = String(text).match(/(\d+)\s*(day|days|week|weeks|month|months|year|years)/i)
    if (!match) return null
    return { count: parseInt(match[1], 10), unit: match[2].toLowerCase().replace(/s$/, '') }
  }

  static _generateUpsellPropertyKey() {
    return '_main_product_upsell_' + Date.now() + '_' + Math.floor(Math.random() * 1000000)
  }

  _findMatchingSellingPlanId(sellingPlans, referenceIntervalName) {
    const referenceInterval = FeesProduct._parseInterval(referenceIntervalName)
    if (!referenceInterval || !sellingPlans || !sellingPlans.length) return null

    const match = sellingPlans.find((plan) => {
      const interval = FeesProduct._parseInterval(plan.name)
      return interval && interval.count === referenceInterval.count && interval.unit === referenceInterval.unit
    })

    return match ? match.id : null
  }

  connectedCallback() {
    let config
    try {
      config = JSON.parse(this.getAttribute('data-config') || '{}')
    } catch (error) {
      console.error('fees-product: invalid data-config', error)
      config = {}
    }

    this.feeEnable = config.feeEnable
    this.additionalDescriptionEnable = config.additionalDescriptionEnable
    this.additionalDescription = config.additionalDescription
    this.page = config.page
    this.currentProductId = config.currentProductId
    this.selectedVariantWeightLb = 0
    this.selectedQuantity = 1
    this.hasSubscriptionSelected = false
    this.fees = (config.fees || []).map((fee) => ({
      product: fee.product,
      sellingPlans: fee.sellingPlans,
      productId: fee.productId,
      productPrice: fee.productPrice,
      productVariantId: fee.productVariantId,
      title: fee.title,
      tooltipText: fee.tooltipText,
      triggerWeight: fee.triggerWeight,
      triggerWeightCondition: fee.triggerWeightCondition,
      triggerProductList: fee.triggerProductList,
    }))
    this.feeProductIds = this.fees.filter((fee) => fee.productId).map((fee) => fee.productId)

    this.innerHTML = `<style>${FeesProduct.STYLES}</style><div data-fees-product-content></div>`
    this._contentEl = this.querySelector('[data-fees-product-content]')
 
    if (this.page !== 'cart') {
      const productSection = this.closest('[data-section-type="product"]')
      this._productSection = productSection
      this._productForm = productSection?.querySelector('[data-product-form]') || null
      if (this._productForm) {
        this._onProductFormSubmit = this._onProductFormSubmit.bind(this)
        this._productForm.addEventListener('submit', this._onProductFormSubmit)
      }


      const initialVariantInput =
        productSection?.querySelector('[data-npt-variant-input]:checked') ||
        productSection?.querySelector('input[name="id"][data-npt-variant-weight]')
      this.selectedVariantWeightLb = parseFloat(initialVariantInput?.getAttribute('data-npt-variant-weight')) || 0

      this._quantityInput = productSection?.querySelector('[data-npt-quantity-input]') || null
      if (this._quantityInput) this.selectedQuantity = parseInt(this._quantityInput.value, 10) || 1

      this._skioPicker = productSection?.querySelector('skio-plan-picker') || null
      this.hasSubscriptionSelected = !!(this._skioPicker && this._skioPicker.selectedSellingPlan)
      if (this._skioPicker) {
        this._onSkioPlanChanged = this._onSkioPlanChanged.bind(this)
        this._skioPicker.addEventListener('change', this._onSkioPlanChanged)
      }

      this._onVariantChanged = this._onVariantChanged.bind(this)
      this._onQuantityChanged = this._onQuantityChanged.bind(this)
      document.addEventListener('npt:variant-changed', this._onVariantChanged)
      document.addEventListener('npt:quantity-changed', this._onQuantityChanged)
    }

    this._applyCartItems(config.cartItems || [])
    this._removeOrphanedFees()
    this._checkTriggers()

    this._onCartUpdated = this._onCartUpdated.bind(this)
    document.addEventListener('cart:updated', this._onCartUpdated)
  }

  disconnectedCallback() {
    document.removeEventListener('cart:updated', this._onCartUpdated)
    if (this._productForm) this._productForm.removeEventListener('submit', this._onProductFormSubmit)
    if (this._skioPicker) this._skioPicker.removeEventListener('change', this._onSkioPlanChanged)
    document.removeEventListener('npt:variant-changed', this._onVariantChanged)
    document.removeEventListener('npt:quantity-changed', this._onQuantityChanged)
  }

  _onVariantChanged(event) {
    this.selectedVariantWeightLb = event.detail.weightLb || 0
    this._checkTriggers()
  }

  _onQuantityChanged(event) {
    this.selectedQuantity = parseInt(event.detail.quantity, 10) || 1
    this._checkTriggers()
  }

  _onSkioPlanChanged() {
    this.hasSubscriptionSelected = !!(this._skioPicker && this._skioPicker.selectedSellingPlan)
    this._checkTriggers()
  }

  _onProductFormSubmit(event) {
    const checkbox = this._contentEl.querySelector('input[type="checkbox"]')
    if (!checkbox || !checkbox.checked || !this._currentMatch) return

    event.preventDefault()

    const fee = this._currentMatch
    const formData = new FormData(this._productForm)
    const variantId = formData.get('id')
    const quantity = parseInt(formData.get('quantity'), 10) || 1
    const sellingPlan = formData.get('selling_plan')
    const submitButton = this._productForm.querySelector('[type="submit"]')

    const upsellPropertyKey = FeesProduct._generateUpsellPropertyKey()

    const mainItem = { id: variantId, quantity, properties: { [upsellPropertyKey]: 'true' } }
    if (sellingPlan) mainItem.selling_plan = sellingPlan

    const feeItem = { id: fee.productVariantId, quantity: 1, properties: { [upsellPropertyKey]: 'true' } }
    if (sellingPlan) {
      const skioPicker = this._productSection?.querySelector('skio-plan-picker')
      const mainSellingPlanName = skioPicker?.selectedSellingPlan?.name
      const feeSellingPlanId = this._findMatchingSellingPlanId(fee.sellingPlans, mainSellingPlanName)
      if (feeSellingPlanId) feeItem.selling_plan = feeSellingPlanId
    }

    checkbox.disabled = true
    if (submitButton) submitButton.disabled = true

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [mainItem, feeItem],
      }),
    })
      .then((response) => response.json().then((body) => ({ ok: response.ok, body })))
      .then(({ ok, body }) => {
        if (!ok) throw new Error(body.description || body.message || JSON.stringify(body))
        window.location.href = '/cart'
      })
      .catch((error) => {
        console.error('fees-product: failed to add items to cart together', error)
        checkbox.disabled = false
        if (submitButton) submitButton.disabled = false
        this._productForm.submit()
      })
  }

  _onCartUpdated(event) {
    fetch('/cart.js')
      .then((response) => response.json())
      .then((cart) => {
        this._applyCartItems(
          cart.items.map((item) => ({
            productId: item.product_id,
            grams: item.grams,
            quantity: item.quantity,
            sellingPlanId: item.selling_plan_allocation?.selling_plan?.id || null,
            sellingPlanName: item.selling_plan_allocation?.selling_plan?.name || null,
            properties: item.properties || {},
          }))
        )
        this._removeOrphanedFees()
        this._checkTriggers()
      })
      .catch((error) => console.error('fees-product: failed to sync cart', error))
  }

  _applyCartItems(items) {
    this.cartItems = items
    this.cartProductIds = items.map((item) => item.productId)
    this.cartWeightGrams = items
      .filter((item) => !this.feeProductIds.includes(item.productId))
      .reduce((total, item) => total + item.grams * item.quantity, 0)
  }

  _mainCartSellingPlanName() {
    const mainItem = (this.cartItems || []).find(
      (item) => !this.feeProductIds.includes(item.productId) && item.sellingPlanName
    )
    return mainItem ? mainItem.sellingPlanName : null
  }

  _effectiveWeightLbs() {
    const cartWeightLb = this.cartWeightGrams / FeesProduct.GRAMS_PER_LB
    const pendingLb = this.page === 'cart' ? 0 : this.selectedVariantWeightLb * (this.selectedQuantity || 1)
    return Math.round((cartWeightLb + pendingLb) * 100) / 100
  }

  _removeOrphanedFees() {
    const updates = {}

    if (this.cartProductIds.length && !this.cartProductIds.some((id) => !this.feeProductIds.includes(id))) {
      this.fees.forEach((fee) => {
        if (fee.productVariantId && this.cartProductIds.includes(fee.productId)) {
          updates[fee.productVariantId] = 0
        }
      })
    }

    (this.cartItems || []).forEach((item) => {
      if (!this.feeProductIds.includes(item.productId)) return

      const properties = item.properties || {}
      const upsellKeys = Object.keys(properties).filter((key) => key.indexOf('_main_product_upsell_') === 0)
      if (!upsellKeys.length) return

      const hasLinkedMainItem = (this.cartItems || []).some(
        (other) =>
          !this.feeProductIds.includes(other.productId) &&
          other.properties &&
          upsellKeys.some((key) => Object.prototype.hasOwnProperty.call(other.properties, key))
      )

      if (!hasLinkedMainItem) {
        const fee = this.fees.find((f) => f.productId === item.productId)
        if (fee && fee.productVariantId) updates[fee.productVariantId] = 0
      }
    })

    if (!Object.keys(updates).length) return

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates }),
    })
      .then((response) => response.json())
      .then(() => (this.page === 'cart' ? this._refreshCartSection() : this._refreshCartCount()))
      .catch((error) => console.error('fees-product: failed to remove orphaned fee', error))
  }

  _checkTriggers() {
    const wasChecked = this._contentEl.querySelector('input[type="checkbox"]')?.checked || false
    const weight = this._effectiveWeightLbs()


    const hasAnyFeeInCart = this.cartProductIds.some((id) => this.feeProductIds.includes(id))

    const matches = hasAnyFeeInCart
      ? []
      : this.fees.filter((fee) => {
          if (!fee.product) return false

          const weightHit =
            fee.triggerWeightCondition === 'greater and equal' ? weight >= fee.triggerWeight : weight <= fee.triggerWeight
          const triggerProductIds = (fee.triggerProductList || []).map((product) => product.id)
          const productHit =
            this.page === 'cart'
              ? this.cartProductIds.some((id) => triggerProductIds.includes(id))
              : triggerProductIds.includes(this.currentProductId)

          return weightHit && productHit
        })

    const match = matches.reduce(
      (largest, fee) =>
        !largest || parseFloat(fee.triggerWeight) > parseFloat(largest.triggerWeight) ? fee : largest,
      null
    )

    this._currentMatch = match

    if (!match) {
      this._contentEl.innerHTML = ''
      return
    }

    const cents = match.productPrice
    const price =
      window.theme && window.theme.Currency
        ? window.theme.Currency.formatMoney(cents, window.theme.moneyFormat)
        : '$' + (cents / 100).toFixed(2)

    const tooltipText = FeesProduct._escapeHtml(match.tooltipText || '')
    const tooltipMarkup = this.feeEnable
      ? `
        <span class="fees-product__info-wrap" tabindex="0">
          <span class="fees-product__info-icon" aria-hidden="true">?</span>
          <span class="fees-product__tooltip" role="tooltip">${tooltipText}</span>
        </span>
      `
      : ''
    const descriptionMarkup = this.feeEnable
      ? `<p class="fees-product__description">${tooltipText}</p>`
      : ''
    const hasSubscription = this.page === 'cart' ? !!this._mainCartSellingPlanName() : this.hasSubscriptionSelected
    const additionalDescriptionMarkup =
      this.additionalDescriptionEnable && this.additionalDescription && hasSubscription
        ? `<div class="fees-product__additional-description">${this.additionalDescription}</div>`
        : ''

    this._contentEl.innerHTML = `
      <p class="fees-product__title">
        ${FeesProduct._escapeHtml(match.title)}
        ${tooltipMarkup}
      </p>
      ${descriptionMarkup}
      <label class="fees-product__option" for="FeesProductCheckbox">
        <input type="checkbox" id="FeesProductCheckbox" name="fees-product" ${wasChecked ? 'checked' : ''}>
        <div class="fees-product__option-text">
          <span>Add insulated cold pack - <span class="fees-product__price">${price}</span></span>
          ${additionalDescriptionMarkup}
        </div>
      </label>
    `


    if (this.page === 'cart') {
      this._contentEl
        .querySelector('input[type="checkbox"]')
        .addEventListener('change', (event) => this._onCheckboxChange(event, match))
    }
  }

  _onCheckboxChange(event, fee) {
    const checkbox = event.target
    if (!checkbox.checked) return

    checkbox.disabled = true

    const feeItem = { id: fee.productVariantId, quantity: 1 }
    const mainSellingPlanName = this._mainCartSellingPlanName()
    const feeSellingPlanId = mainSellingPlanName ? this._findMatchingSellingPlanId(fee.sellingPlans, mainSellingPlanName) : null
    if (feeSellingPlanId) feeItem.selling_plan = feeSellingPlanId

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [feeItem] }),
    })
      .then((response) => response.json().then((body) => ({ ok: response.ok, body })))
      .then(({ ok, body }) => {
        if (!ok) throw new Error(body.description || body.message || JSON.stringify(body))
        return this.page === 'cart' ? this._refreshCartSection() : this._refreshCartCount()
      })
      .catch((error) => {
        console.error('fees-product: failed to add to cart', error)
        checkbox.disabled = false
        checkbox.checked = false
      })
  }


  _refreshCartCount() {
    return fetch('/cart.js')
      .then((response) => response.json())
      .then((cart) => {
        this._contentEl.innerHTML = ''
        this._updateCartCountBubble(cart.item_count)

        document.dispatchEvent(
          new CustomEvent('cart:updated', {
            detail: {
              items: cart.items.map((item) => ({
                productId: item.product_id,
                grams: item.grams,
                quantity: item.quantity,
                sellingPlanId: item.selling_plan_allocation?.selling_plan?.id || null,
                sellingPlanName: item.selling_plan_allocation?.selling_plan?.name || null,
                properties: item.properties || {},
              })),
            },
          })
        )
      })
  }


  _refreshCartSection() {
    const sectionEl = this.closest('[data-section-type="cart-template"]')
    const sectionId = sectionEl && sectionEl.dataset.sectionId

    if (!sectionEl || !sectionId) return this._refreshCartCount()

    return fetch(`/cart?section_id=${sectionId}`)
      .then((response) => response.text())
      .then((html) => {
        const newSection = new DOMParser()
          .parseFromString(html, 'text/html')
          .querySelector('[data-section-type="cart-template"]')

        if (newSection) sectionEl.replaceWith(newSection)

        return fetch('/cart.js')
      })
      .then((response) => response.json())
      .then((cart) => this._updateCartCountBubble(cart.item_count))
  }

  _updateCartCountBubble(quantity) {
    const bubble = document.querySelector('[data-cart-count-bubble]')
    const count = document.querySelector('[data-cart-count]')

    if (bubble) bubble.classList.remove('hide')
    if (count) count.textContent = quantity
  }
}

customElements.define('fees-product', FeesProduct)